




















































































import { Vue, Component } from "vue-property-decorator";
import Toggle from "@/modules/customization/components/Toggle.vue";
import ColorPicker from "@/modules/customization/components/ColorPicker.vue";
import { namespace } from "vuex-class";
import { Gradient, FontFamily } from "../types";

const Customization = namespace("customization");

@Component({
  components: {
    "color-picker": ColorPicker,
    toggle: Toggle,
  },
})
export default class Sidebar extends Vue {
  @Customization.Getter("getAccentColor") accentColor: string;
  @Customization.Getter("getSecondaryColor") secondaryColor: string;
  @Customization.Getter("getGradient") gradient: Gradient;
  @Customization.Getter("getFontFamily") fontFamily: FontFamily;
  @Customization.Action("setAccentColor") setAccentColor;
  @Customization.Action("setSecondaryColor") setSecondaryColor;
  @Customization.Action("setGradientStart") setGradientStart;
  @Customization.Action("setGradientStop") setGradientStop;
  @Customization.Action("setFontFamily") setFontFamily;
  @Customization.Action("publishTheme") publishTheme;
  @Customization.Action("resetTheme") resetTheme;

  fonts = [
    {
      name: "Poppins",
      value:
        "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Open+Sans:wght@400;600&display=swap",
    },
    {
      name: "Lato",
      value:
        "https://fonts.googleapis.com/css2?family=Lato:wght@100&display=swap",
    },
    {
      name: "Open Sans",
      value:
        "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&display=swap",
    },
    {
      name: "Roboto Slab",
      value:
        "https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;500&display=swap",
    },
  ];

  loading = false;

  updateAccentColor(color) {
    this.setAccentColor(color);
  }

  updateSecondaryColor(color) {
    this.setSecondaryColor(color);
  }

  updateGradientStartColor(color) {
    this.setGradientStart(color);
  }

  updateGradientStopColor(color) {
    this.setGradientStop(color);
  }

  updateFontFamily(payload) {
    this.setFontFamily(payload);
  }

  publishCurrentTheme() {
    this.loading = true;
    this.publishTheme()
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Theme published successfully.",
        });
      })
      .catch(() => {
        this.loading = false;
        this.$notify({
          group: "error",
          title: "Error",
          text: "An error occurred",
        });
      });
  }
  setDefaultTheme() {
    this.resetTheme();
  }
}
